import React, { use, useEffect, useState } from 'react'
import ServiceCatalogueTable from './ServiceCatalogueTable'
import ServiceFields from './ServiceFields'
import { toast } from 'react-toastify'
import AddCatalogue from './AddCatalogue'
import api from '../../utils/api'

const ServiceCatalogueHome = () => {

    const [serviceFields, setServiceFields] = useState({
        fAmountFirst: 0,
        fAmountSecond: 0,
        fAmountFull: 0,
        sCatalogueId: "",
        sPaymentMode: "",
        sDeliveryMode: '',
        sPaymentReceiver: '',
        sMode: '',
        nKey: '',
        sServiceCode: '',
        // nExpectedTAT: 0,
    })

    const [isEditClicked, setIsEditClicked] = useState(false)
    const [isAddClicked, setIsAddClicked] = useState(false)


    // const serviceCodeOptions = [
    //     {
    //         "sServiceCode": "CCR"
    //     },
    //     {
    //         "sServiceCode": "FINANCIALVIA"
    //     },
    //     {
    //         "sServiceCode": "FUNDFCLTY"
    //     },
    //     {
    //         "sServiceCode": "IMPBIZPERF"
    //     },
    //     {
    //         "sServiceCode": "ADVISORY"
    //     },
    //     {
    //         "sServiceCode": "BANNERDESIGN"
    //     },
    //     {
    //         "sServiceCode": "BARCODING"
    //     },
    //     {
    //         "sServiceCode": "BOOKACCBALKEEP"
    //     },
    //     {
    //         "sServiceCode": "BROCHURESDESIGN"
    //     },
    //     {
    //         "sServiceCode": "BUSFUNDCONSULT"
    //     },
    //     {
    //         "sServiceCode": "BUSINESSPLAN"
    //     },
    //     {
    //         "sServiceCode": "BUSSSTRG"
    //     },
    //     {
    //         "sServiceCode": "CASHBUGTMGMT"
    //     },
    //     {
    //         "sServiceCode": "CASHLESS"
    //     },
    //     {
    //         "sServiceCode": "CCR"
    //     },
    //     {
    //         "sServiceCode": "COACHCONPRO"
    //     },
    //     {
    //         "sServiceCode": "COMMTOOLS"
    //     },
    //     {
    //         "sServiceCode": "COMPFORM"
    //     },
    //     {
    //         "sServiceCode": "COPYRIGHT"
    //     },
    //     {
    //         "sServiceCode": "DAILYEXPSEMGMT"
    //     },
    //     {
    //         "sServiceCode": "DEPRELISTING"
    //     },
    //     {
    //         "sServiceCode": "DIGIMKTR"
    //     },
    //     {
    //         "sServiceCode": "DIGITALPAY"
    //     },
    //     {
    //         "sServiceCode": "DISPLAYSDESIGN"
    //     },
    //     {
    //         "sServiceCode": "ESTORE"
    //     },
    //     {
    //         "sServiceCode": "EXPRTCONSULT"
    //     },
    //     {
    //         "sServiceCode": "FBLIVESELL"
    //     },
    //     {
    //         "sServiceCode": "FBSHOPSETUP"
    //     },
    //     {
    //         "sServiceCode": "FINANCIALVIA"
    //     },
    //     {
    //         "sServiceCode": "FLYERSDESIGN"
    //     },
    //     {
    //         "sServiceCode": "FSSAI"
    //     },
    //     {
    //         "sServiceCode": "FSSAILICENSE"
    //     },
    //     {
    //         "sServiceCode": "FUNDFCLTY"
    //     },
    //     {
    //         "sServiceCode": "FUNDRDYPRPSL"
    //     },
    //     {
    //         "sServiceCode": "GOOGLEMYBUSLISTING"
    //     },
    //     {
    //         "sServiceCode": "GOONLINE"
    //     },
    //     {
    //         "sServiceCode": "GRPEXPRTCONSULT"
    //     },
    //     {
    //         "sServiceCode": "GSTREG"
    //     },
    //     {
    //         "sServiceCode": "GSTRETURNFILING"
    //     },
    //     {
    //         "sServiceCode": "IMPBIZPERF"
    //     },
    //     {
    //         "sServiceCode": "INVCERCPTMGNT"
    //     },
    //     {
    //         "sServiceCode": "ITR"
    //     },
    //     {
    //         "sServiceCode": "LLPFORM"
    //     },
    //     {
    //         "sServiceCode": "LLPROCCOMPAMC"
    //     },
    //     {
    //         "sServiceCode": "LS"
    //     },
    //     {
    //         "sServiceCode": "LTEXP"
    //     },
    //     {
    //         "sServiceCode": "LTEXPCOACH"
    //     },
    //     {
    //         "sServiceCode": "LVLICENSEAGR"
    //     },
    //     {
    //         "sServiceCode": "LVLICENSEAGRREG"
    //     },
    //     {
    //         "sServiceCode": "MENTALHEALTHGUIDANCE"
    //     },
    //     {
    //         "sServiceCode": "MENTORCONSULT"
    //     },
    //     {
    //         "sServiceCode": "MKTR"
    //     },
    //     {
    //         "sServiceCode": "MPOS"
    //     },
    //     {
    //         "sServiceCode": "MRKTINGPLANASSESS"
    //     },
    //     {
    //         "sServiceCode": "MRKTMTRL"
    //     },
    //     {
    //         "sServiceCode": "MRKTRSRCH"
    //     },
    //     {
    //         "sServiceCode": "ONLBUSLISTINGS"
    //     },
    //     {
    //         "sServiceCode": "ONLMRKTPLACEREG"
    //     },
    //     {
    //         "sServiceCode": "OPCFORM"
    //     },
    //     {
    //         "sServiceCode": "OPCROCCOMPAMC"
    //     },
    //     {
    //         "sServiceCode": "PACKAGINGDESIGN"
    //     },
    //     {
    //         "sServiceCode": "PAIDCAMPMNGT"
    //     },
    //     {
    //         "sServiceCode": "PARTSHIPDEED"
    //     },
    //     {
    //         "sServiceCode": "PATENT"
    //     },
    //     {
    //         "sServiceCode": "PAYTRAC"
    //     },
    //     {
    //         "sServiceCode": "PKGLBL"
    //     },
    //     {
    //         "sServiceCode": "PRJRPT"
    //     },
    //     {
    //         "sServiceCode": "PVTLTDCOMP"
    //     },
    //     {
    //         "sServiceCode": "PVTLTDROCCOMPAMC"
    //     },
    //     {
    //         "sServiceCode": "QRCODE"
    //     },
    //     {
    //         "sServiceCode": "RECONLOAN"
    //     },
    //     {
    //         "sServiceCode": "SHOPACT"
    //     },
    //     {
    //         "sServiceCode": "SHOPACTREG"
    //     },
    //     {
    //         "sServiceCode": "SIGNAGESDESIGN"
    //     },
    //     {
    //         "sServiceCode": "SMMPRO"
    //     },
    //     {
    //         "sServiceCode": "SMMPROPLUS"
    //     },
    //     {
    //         "sServiceCode": "SMMSTRT"
    //     },
    //     {
    //         "sServiceCode": "SMMSTRTPLUS"
    //     },
    //     {
    //         "sServiceCode": "SMMSTRTPRO"
    //     },
    //     {
    //         "sServiceCode": "SMMSTRTPROPLUS"
    //     },
    //     {
    //         "sServiceCode": "SOCIALMEDIAMGMT"
    //     },
    //     {
    //         "sServiceCode": "SOCIALMEDIASTRAT"
    //     },
    //     {
    //         "sServiceCode": "STANDEESBANNERDESIGN"
    //     },
    //     {
    //         "sServiceCode": "STANDEESDESIGN"
    //     },
    //     {
    //         "sServiceCode": "SUBSCRIPMGNT"
    //     },
    //     {
    //         "sServiceCode": "TASKMGT"
    //     },
    //     {
    //         "sServiceCode": "TERMLOANR"
    //     },
    //     {
    //         "sServiceCode": "TOWNSQUR"
    //     },
    //     {
    //         "sServiceCode": "TRADMRK"
    //     },
    //     {
    //         "sServiceCode": "UDOGADHAR"
    //     },
    //     {
    //         "sServiceCode": "UDYAMREG"
    //     },
    //     {
    //         "sServiceCode": "VALSTOCKASSETS"
    //     },
    //     {
    //         "sServiceCode": "WEBDSGNDEV"
    //     },
    //     {
    //         "sServiceCode": "WHATAPPFORBUSINESS"
    //     },
    //     {
    //         "sServiceCode": "WORKINGCAPLOAN"
    //     }
    // ]

    const [serviceCodeOptions, setServiceCodeOptions] = useState()

    // const uniqueServiceCodes = new Set();

    // const uniqueOptions = serviceCodeOptions.filter((option) => {
    //     const { sServiceCode } = option;
    //     if (!uniqueServiceCodes.has(sServiceCode)) {
    //         uniqueServiceCodes.add(sServiceCode);
    //         return true;
    //     }
    //     return false;
    // }).map((option) => {
    //     const { sServiceCode } = option;
    //     return {
    //         value: sServiceCode,
    //         label: sServiceCode,
    //     };
    // });

    const [selectedServiceCode, setSelectedServiceCode] = useState("")

    const onServiceCodeChange = (option) => {
        console.log("seee", option);
        console.log(serviceCodeOptions, ">>>serviceCodeOptions");

        const isUniqueServiceCode = serviceCatalogueData.every(item => item.sServiceCode !== option.value);
        // setSelectedServiceCode(option)
        if (isUniqueServiceCode) {
            setSelectedServiceCode(option);

            if (option?.nExpectedTAT == "" || option?.nExpectedTAT == null || option?.nExpectedTAT <= 0) {
                setExpectedTat(0);
                setIsExpectedTatDisabled(false);
            } else {
                setExpectedTat(option?.nExpectedTAT);
                setIsExpectedTatDisabled(true)
            }

        } else {
            // Show an error message because the service code is not unique
            toast("Service code is not unique. Please choose a different service code.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    }

    // const [paymentOption, setPaymentOption] = useState([
    //     {
    //         value: "No_Payment",
    //         label: "No Payment",
    //     },
    //     {
    //         value: "2_Step_Payment",
    //         label: "2 Step Payment",
    //     },
    //     {
    //         value: "1_Step_Payment",
    //         label: "1 Step Payment",
    //     },
    //     {
    //         value: "SP_Paid_Service",
    //         label: "SP Paid Service",
    //     },
    // ])

    // const [deliveryMode, setDeliveryMode] = useState([
    //     {
    //         value: "DIY",
    //         label: 'DIY'
    //     },
    //     {
    //         value: "Offline",
    //         label: 'Offline'
    //     },
    //     {
    //         value: "Self-Served",
    //         label: 'Self-Served'
    //     }
    // ])

    const [deliveryMode, setDeliveryMode] = useState()
    const [paymentOption, setPaymentOption] = useState()
    const [defaultPaymentReceiver, setDefaultPaymentReceiver] = useState()
    const [paymentReceiver, setPaymentReceiver] = useState()
    const [mode, setMode] = useState()
    const [defaultModeOptions, setDefaultModeOptions] = useState()
    const [serviceCatalogueData, setServiceCatalogueData] = useState()

    // const [paymentReceiver, setPaymentReceiver] = useState([
    //     {
    //         value: "deasra",
    //         label: 'deasra'
    //     },
    //     {
    //         value: "partner",
    //         label: 'partner'
    //     },
    // ])

    // const [mode, setMode] = useState([
    //     {
    //         value: "FIXED_UserDriven",
    //         label: 'FIXED_UserDriven'
    //     },
    //     {
    //         value: "FIXED_DeAsraDriven",
    //         label: 'FIXED_DeAsraDriven'
    //     },
    //     {
    //         value: "FIXED_PartnerDriven",
    //         label: 'FIXED_PartnerDriven'
    //     },
    //     {
    //         value: "DYNAMIC_DeAsraDriven",
    //         label: 'DYNAMIC_DeAsraDriven'
    //     },
    //     {
    //         value: "DYNAMIC_PartnerDriven",
    //         label: 'DYNAMIC_PartnerDriven'
    //     },
    //     {
    //         value: "DYNAMIC_UserDriven",
    //         label: 'DYNAMIC_UserDriven'
    //     }
    // ])

    const [
        GSTPercentageOptions,
        setGSTPercentageOptions,
    ] = useState([
        {
            value: "2",
            label: "2%",
        },
        {
            value: "5",
            label: "5%",
        },
        {
            value: "12",
            label: "12%",
        },
        {
            value: "18",
            label: "18%",
        },
        {
            value: "25",
            label: "25%",
        },
        {
            value: "28",
            label: "28%",
        },
    ]);
    const [
        selectedGSTPercentageOption,
        setSelectedGSTPercentageOption,
    ] = useState({
        value: "18",
        label: "18%",
    });

    const [executionOwnerOptions, setExecutionOwnerOptions] = useState([
        {
            value: "deAsraLed",
            label: "deAsraLed"
        },
        {
            value: "SPLed",
            label: "SPLed"
        },
    ])

    const [defaultExecutionOwnerOptions, setDefaultExecutionOwnerOptions] = useState([
        {
            value: "deAsraLed",
            label: "deAsraLed"
        },
        {
            value: "SPLed",
            label: "SPLed"
        },
    ])

    const [selectedExectionOwner, setSelectedExecutionOwner] = useState({
        value: "SPLed",
        label: "SPLed"
    })

    const [selectedPaymentType, setSelectedPaymentType] = useState("")
    const [selectedDeliveryMode, setSelectedDeliveryMode] = useState("")
    const [selectedPaymentReceiver, setSelectedPaymentReceiver] = useState("")
    const [selectedMode, setSelectedMode] = useState("")
    const [catalogueId, setCatalogueId] = useState("")
    const [expectedTat, setExpectedTat] = useState("")
    const [isExpectedTatDisabled, setIsExpectedTatDisabled] = useState(false);

    const handleExpectedTatChange = (value) => {
        setExpectedTat(value)
    }

    const getServiceCatalogueTableData = () => {
        const { tempDeliveryMode } = api.deliveryModeDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Delivery Type", data)

                    function sortByDeliveryMode(arr, order = 'asc') {
                        return arr.sort((a, b) => {
                            const modeA = a.DeliveryMode.toUpperCase();
                            const modeB = b.DeliveryMode.toUpperCase();

                            if (modeA < modeB) return order === 'asc' ? -1 : 1;
                            if (modeA > modeB) return order === 'asc' ? 1 : -1;
                            return 0;
                        });
                    }

                    let sortedDeliveryMode = sortByDeliveryMode(data)

                    const convertedDeliveryType = sortedDeliveryMode.map(item => ({
                        value: item.DeliveryMode,
                        label: item.DeliveryMode
                    }))
                    setDeliveryMode(convertedDeliveryType)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempPaymentMode } = api.paymentModeDropdwonData()
            .then(({ data }) => {
                if (data) {
                    console.log("Payment Type", data)

                    function sortByPaymentMode(arr, order = 'asc') {
                        return arr.sort((a, b) => {
                            const modeA = a.PaymentMode.toUpperCase();
                            const modeB = b.PaymentMode.toUpperCase();

                            if (modeA < modeB) return order === 'asc' ? -1 : 1;
                            if (modeA > modeB) return order === 'asc' ? 1 : -1;
                            return 0;
                        });
                    }

                    let sortedPaymentMode = sortByPaymentMode(data);

                    const convertedPaymentType = sortedPaymentMode.map(item => ({
                        value: item.PaymentMode,
                        label: item.PaymentMode
                    }))

                    setPaymentOption(convertedPaymentType)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempPaymentReceiver } = api.paymentRecieverDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Payment Type", data)

                    function sortPaymentReceiverOption(arr, order = 'asc') {
                        return arr.sort((a, b) => {
                            const modeA = a.PaymentReceiver.toUpperCase();
                            const modeB = b.PaymentReceiver.toUpperCase();

                            if (modeA < modeB) return order === 'asc' ? -1 : 1;
                            if (modeA > modeB) return order === 'asc' ? 1 : -1;
                            return 0;
                        });
                    }

                    let sortedPaymentReceiverOption = sortPaymentReceiverOption(data);

                    const convertedPaymentReceiver = sortedPaymentReceiverOption.map(item => ({
                        value: item.PaymentReceiver,
                        label: item.PaymentReceiver
                    }))
                    setPaymentReceiver(convertedPaymentReceiver)
                    setDefaultPaymentReceiver(convertedPaymentReceiver)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempMode } = api.sModeDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Payment Type", data)

                    function sortModeData(arr, order = 'asc') {
                        return arr.sort((a, b) => {
                            const modeA = a.sMode.toUpperCase();
                            const modeB = b.sMode.toUpperCase();

                            if (modeA < modeB) return order === 'asc' ? -1 : 1;
                            if (modeA > modeB) return order === 'asc' ? 1 : -1;
                            return 0;
                        });
                    }

                    let sortedMode = sortModeData(data)

                    const convertedMode = sortedMode.map(item => ({
                        value: item.sMode,
                        label: item.sMode
                    }))
                    setMode(convertedMode)
                    setDefaultModeOptions(convertedMode)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempServiceCode } = api.serviceCodeDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Service Code", data)

                    function sortByServiceCode(arr, order = 'asc') {
                        return arr.sort((a, b) => {
                            const codeA = a.sServiceCode.toUpperCase();
                            const codeB = b.sServiceCode.toUpperCase();

                            if (codeA < codeB) return order === 'asc' ? -1 : 1;
                            if (codeA > codeB) return order === 'asc' ? 1 : -1;
                            return 0;
                        });
                    }
                    let sortedData = sortByServiceCode(data)

                    const convertedServiceCode = sortedData.map(item => ({
                        value: item.sServiceCode,
                        label: item.sServiceCode,
                        nExpectedTAT: item.nExpectedTAT
                    }))
                    setServiceCodeOptions(convertedServiceCode)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempServiceCatalogue } = api.getServiceCatalogueData()
            .then(({ data }) => {
                console.log("Service Catalogue", data)
                setServiceCatalogueData(data)
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })


    }

    useEffect(() => {
        console.log("useeffect is called")
        getServiceCatalogueTableData()
    }, [])

    useEffect(() => {
        if (selectedPaymentType.value === "SP_paid_service") {
            const options = paymentReceiver.filter(
                (option) => option.value === "Partner"
            )
            setPaymentReceiver(options)

            const options2 = executionOwnerOptions.filter(
                (option) => option.value === "SPLed"
            )
            setExecutionOwnerOptions(options2)
            setSelectedExecutionOwner({
                value: "SPLed",
                label: "SPLed"
            })
        } else {
            setPaymentReceiver(defaultPaymentReceiver)
            setExecutionOwnerOptions(defaultExecutionOwnerOptions)
        }

    }, [selectedPaymentType])

    useEffect(() => {
        if (selectedPaymentReceiver.value === "deAsra") {
            const options = defaultModeOptions.filter(
                (option) => option.value === "FIXED_DeAsraDriven" || option.value === "FIXED_UserDriven" || option.value === "DYNAMIC_UserDriven" || option.value === "DYNAMIC_DeAsraDriven"
            )
            setMode(options)
        } else if (selectedPaymentReceiver.value === "Partner") {
            const options = defaultModeOptions.filter(
                (option) => option.value === "DYNAMIC_PartnerDriven" || option.value === "FIXED_PartnerDriven"
            )
            setMode(options)
        } else {
            setMode(defaultModeOptions)
        }
    }, [selectedPaymentReceiver])

    const onPaymentChange = (option) => {
        console.log(option, ">>>payment mode selected option");
        if (option.value === "No_Payment") {
            // setSelectedPaymentReceiver("");
            // setSelectedMode("")
            setSelectedPaymentReceiver({ value: 'deAsra', label: 'deAsra' })
            setSelectedMode({ value: 'FIXED_DeAsraDriven', label: 'FIXED_DeAsraDriven' });
        }

        setSelectedPaymentType(option)
        console.log("SelPay", selectedPaymentType)
        setServiceFields(prevServiceFields => ({
            ...prevServiceFields,
            fAmountFirst: "0",
            fAmountSecond: "0",
        }));
    }

    const onDeliveryModeChange = (option) => {
        setSelectedDeliveryMode(option)
    }

    const onPaymentReceiverChange = (option) => {
        setSelectedPaymentReceiver(option)
    }

    const onModeChange = (option) => {
        setSelectedMode(option)
    }

    const onGstPercentChange = (option) => {
        setSelectedGSTPercentageOption(option)
    }

    const onExecutionOwnerChange = (option) => {
        setSelectedExecutionOwner(option)
    }

    const addCatalogueBtn = () => {
        setIsAddClicked(true)
    }

    const editCatalogue = (e) => {
        console.log(e, ">>>>e");
        
        setServiceFields({
            fAmountFirst: Number(e.fAmountFirst),
            fAmountFull: e.fAmountFull,
            sCatalogueId: e.sCatalogueId,
            sPaymentMode: e.sPaymentMode,
            fAmountSecond: e.fAmountSecond,
            // nExpectedTAT: e.nExpectedTAT,
        })
        setExpectedTat(e.nExpectedTAT)
        setCatalogueId(e.id)
        setIsEditClicked(true)
        console.log("DataCat", serviceFields)
        const selectedOption = {
            value: e.sPaymentMode,
            label: e.sPaymentMode
        };
        const deliveryModeOption = {
            value: e.sDeliveryMode,
            label: e.sDeliveryMode
        }
        const paymentReceiverOption = {
            value: e.sPaymentReceiver,
            label: e.sPaymentReceiver
        }
        const modeOption = {
            value: e.sMode,
            label: e.sMode
        }
        const selectedGst = {
            value: e.fGST,
            label: `${e.fGST}%`
        }
        const selectedExecution = {
            value: e.sExecutionOwner,
            label: e.sExecutionOwner
        }
        const selectedSerCode = {
            value: e.sServiceCode,
            label: e.sServiceCode
        }
        setSelectedPaymentType(selectedOption);
        setSelectedDeliveryMode(deliveryModeOption)
        setSelectedPaymentReceiver(paymentReceiverOption)
        setSelectedMode(modeOption)
        setSelectedGSTPercentageOption(selectedGst)
        setSelectedExecutionOwner(selectedExecution)
        setSelectedServiceCode(selectedSerCode)
        console.log(e.sPaymentMode)
    }

    const BackPage = () => {
        setIsEditClicked(false)
        setServiceFields({
            fAmountFirst: 0,
            fAmountFull: 0,
            fAmountSecond: 0,
            sCatalogueId: "",
            sPaymentMode: "",
            // nExpectedTAT: 0,
        })
        setExpectedTat(0)
        setIsExpectedTatDisabled(false);
        setSelectedPaymentType("");
        setSelectedDeliveryMode("")
        setSelectedPaymentReceiver("")
        setSelectedMode("")
        setSelectedGSTPercentageOption({
            value: "18",
            label: "18%",
        })
        setSelectedExecutionOwner({
            value: "SPLed",
            label: "SPLed"
        })
        setSelectedServiceCode("")
    }

    const BackPage1 = () => {
        setIsAddClicked(false)
        setSelectedPaymentType("");
        setSelectedDeliveryMode("")
        setSelectedPaymentReceiver("")
        setSelectedMode("")
        setSelectedGSTPercentageOption({
            value: "18",
            label: "18%",
        })
        setSelectedExecutionOwner({
            value: "SPLed",
            label: "SPLed"
        })
        setSelectedServiceCode("")
    }

    const handleChange = (name, value) => {
        console.log(name, value, ">>>>name and value onChange TAT");

        const updated = { ...serviceFields, [name]: value };
        setServiceFields(updated);

        const {
            fAmountFirst,
            fAmountFull,
            fAmountSecond,
            sCatalogueId,
            // nExpectedTAT,
        } = updated;

        if (name === 'sCatalogueId') {
            const isUniqueCatalogueId = serviceCatalogueData.every(item => item.sCatalogueId !== value)

            if (!isUniqueCatalogueId) {
                toast("Catalogue Id is not unique. Please choose a different Catalogue Id.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }
    };

    const onSaveClick = () => {
        const isUniqueCatalogueId = serviceCatalogueData.every(item => item.sCatalogueId !== serviceFields.sCatalogueId)
        try {
            if (serviceFields.sCatalogueId === "") {
                toast("Catalogue Id is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            //  else if (!isUniqueCatalogueId) {
            //     toast("Catalogue Id is not unique", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // }
            else if (selectedServiceCode === "" || selectedServiceCode === null) {
                toast("Service Code is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedDeliveryMode === "" || selectedDeliveryMode === null) {
                toast("Delivery Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType === "" || selectedPaymentType === null) {
                toast("Payment Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentReceiver === "" || selectedPaymentReceiver === null) {
                toast("Payment Receiver is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedMode === "" || selectedMode === null) {
                toast("Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && (serviceFields.fAmountFirst === "")) {
                toast("Amount First is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && serviceFields.fAmountSecond === "") {
                toast("Amount Second is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && serviceFields.fAmountFull === "") {
                toast("Amount Full is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && (selectedGSTPercentageOption === "" || selectedGSTPercentageOption === null)) {
                toast("GST Percentage is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (serviceFields.nExpectedTAT === "") {
                toast("Expected TAT is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedExectionOwner === "" || selectedExectionOwner === null) {
                toast("Execution Owner is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else {
                let payload = {
                    fAmountFirst: Number(serviceFields.fAmountFirst),
                    fAmountSecond: Number(serviceFields.fAmountSecond),
                    // fAmountFull: Number(serviceFields.fAmountFull),
                    fAmountFull: Number(serviceFields.fAmountFirst) + Number(serviceFields.fAmountSecond),
                    sCatalogueId: serviceFields.sCatalogueId,
                    sPaymentMode: selectedPaymentType.value,
                    sDeliveryMode: selectedDeliveryMode.value,
                    sPaymentReceiver: selectedPaymentReceiver.value,
                    sMode: selectedMode.value,
                    // sServiceCode: selectedServiceCode.value,
                    nExpectedTAT: Number(expectedTat),
                    fGST: Number(selectedGSTPercentageOption.value),
                    sExecutionOwner: selectedExectionOwner.value
                }
                api.updateServiceCatalogueData(payload, catalogueId)
                    .then(({ data }) => {
                        console.log("Yoo", data)
                        toast("Edited Catalogue", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        })
                        setIsEditClicked(false)
                        setIsAddClicked(false)
                        getServiceCatalogueTableData()
                        setServiceFields({
                            fAmountFirst: 0,
                            fAmountFull: 0,
                            fAmountSecond: 0,
                            sCatalogueId: "",
                            sPaymentMode: "",
                            sServiceCode: "",
                            // nExpectedTAT: 0,
                        })
                        setExpectedTat(0);
                        setIsExpectedTatDisabled(false);
                        setSelectedPaymentType("");
                        setSelectedDeliveryMode("")
                        setSelectedPaymentReceiver("")
                        setSelectedMode("")
                        setSelectedGSTPercentageOption({
                            value: "18",
                            label: "18%",
                        })
                        setSelectedExecutionOwner({
                            value: "SPLed",
                            label: "SPLed"
                        })
                        setSelectedServiceCode("")
                    })
            }
        } catch (error) {
            toast("Something Went Wrong", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }

    }

    const onSaveClick1 = () => {
        const isUniqueCatalogueId = serviceCatalogueData.every(item => item.sCatalogueId !== serviceFields.sCatalogueId)
        try {
            if (serviceFields.sCatalogueId === "") {
                toast("Catalogue Id is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (!isUniqueCatalogueId) {
                toast("Catalogue Id is not unique", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedServiceCode === "" || selectedServiceCode === null) {
                toast("Service Code is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedDeliveryMode === "" || selectedDeliveryMode === null) {
                toast("Delivery Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType === "" || selectedPaymentType === null) {
                toast("Payment Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentReceiver === "" || selectedPaymentReceiver === null) {
                toast("Payment Receiver is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedMode === "" || selectedMode === null) {
                toast("Mode is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && (serviceFields.fAmountFirst === "")) {
                toast("Amount First is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && serviceFields.fAmountSecond === "") {
                toast("Amount Second is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (serviceFields.fAmountFull === "") {
                toast("Amount Full is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedPaymentType?.value !== "No_Payment" && (selectedGSTPercentageOption === "" || selectedGSTPercentageOption === null)) {
                toast("GST Percentage is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (serviceFields.nExpectedTAT === "") {
                toast("Expected TAT is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedExectionOwner === "" || selectedExectionOwner === null) {
                toast("Execution Owner is Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            else {
                let payload = {
                    fAmountFirst: Number(serviceFields.fAmountFirst),
                    fAmountSecond: Number(serviceFields.fAmountSecond),
                    // fAmountFull: Number(serviceFields.fAmountFull),
                    fAmountFull: Number(serviceFields.fAmountFirst) + Number(serviceFields.fAmountSecond),
                    sCatalogueId: serviceFields.sCatalogueId,
                    sPaymentMode: selectedPaymentType.value,
                    sDeliveryMode: selectedDeliveryMode.value,
                    sPaymentReceiver: selectedPaymentReceiver.value,
                    sMode: selectedMode.value,
                    sServiceCode: selectedServiceCode.value,
                    // nExpectedTAT: Number(serviceFields.nExpectedTAT),
                    nExpectedTAT: Number(expectedTat),
                    fGST: Number(selectedGSTPercentageOption.value),
                    sExecutionOwner: selectedExectionOwner.value
                }
                api.addServiceCatalogueData(payload)
                    .then(({ data }) => {
                        if (data.Message === "Service Catalogue Created Successfully.") {
                            toast("Added Catalogue", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            })
                            setIsEditClicked(false)
                            setIsAddClicked(false)
                            getServiceCatalogueTableData()
                            setServiceFields({
                                fAmountFirst: 0,
                                fAmountFull: 0,
                                fAmountSecond: 0,
                                sCatalogueId: "",
                                sPaymentMode: "",
                                sServiceCode: "",
                                // nExpectedTAT: 0,
                            })
                            setExpectedTat(0)
                            setIsExpectedTatDisabled(false);
                            setSelectedPaymentType("");
                            setSelectedDeliveryMode("")
                            setSelectedPaymentReceiver("")
                            setSelectedMode("")
                            setSelectedGSTPercentageOption({
                                value: "18",
                                label: "18%",
                            })
                            setSelectedExecutionOwner({
                                value: "SPLed",
                                label: "SPLed"
                            })
                            setSelectedServiceCode("")
                        } else {
                            toast(data.Message, {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            })
                        }
                    })
                console.log("Yoo", payload)

            }
        } catch (error) {
            toast("Something Went Wrong", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    }

    return (
        <div>
            <div className="row mt-3">
                <div className="col-12">
                    <label>
                        <b>Service Catalogue View</b>
                    </label>
                </div>
            </div>
            {
                !isEditClicked && !isAddClicked ?
                    <div className="row  mb-3">
                        <div className="col-12">
                            <ServiceCatalogueTable
                                handleChange={handleChange}
                                editCatalogue={editCatalogue}
                                addCatalogueBtn={addCatalogueBtn}
                                serviceCatalogueData={serviceCatalogueData}
                                getServiceCatalogueTableData={getServiceCatalogueTableData}

                                expectedTat={expectedTat}
                                handleExpectedTatChange={handleExpectedTatChange}
                                isExpectedTatDisabled={isExpectedTatDisabled}
                            />
                        </div>
                    </div>
                    :
                    isEditClicked ?
                        <div className="row">
                            <div className="col-12">
                                <ServiceFields
                                    handleChange={handleChange}
                                    serviceFields={serviceFields}
                                    BackPage={BackPage}
                                    onPaymentChange={onPaymentChange}
                                    onDeliveryModeChange={onDeliveryModeChange}
                                    onPaymentReceiverChange={onPaymentReceiverChange}
                                    onModeChange={onModeChange}
                                    paymentOption={paymentOption}
                                    deliveryMode={deliveryMode}
                                    paymentReceiver={paymentReceiver}
                                    mode={mode}
                                    selectedPaymentType={selectedPaymentType}
                                    selectedDeliveryMode={selectedDeliveryMode}
                                    selectedPaymentReceiver={selectedPaymentReceiver}
                                    selectedMode={selectedMode}
                                    onSaveClick={onSaveClick}
                                    GSTPercentageOptions={GSTPercentageOptions}
                                    onGstPercentChange={onGstPercentChange}
                                    selectedGSTPercentageOption={selectedGSTPercentageOption}
                                    executionOwnerOptions={executionOwnerOptions}
                                    onExecutionOwnerChange={onExecutionOwnerChange}
                                    selectedExectionOwner={selectedExectionOwner}
                                    selectedServiceCode={selectedServiceCode}
                                    onServiceCodeChange={onServiceCodeChange}
                                    serviceCodeOptions={serviceCodeOptions}

                                    expectedTat={expectedTat}
                                    handleExpectedTatChange={handleExpectedTatChange}
                                    isExpectedTatDisabled={isExpectedTatDisabled}
                                />
                            </div>
                        </div>
                        :
                        isAddClicked ?
                            <div className="row">
                                <div className="col-12">
                                    <AddCatalogue
                                        handleChange={handleChange}
                                        serviceFields={serviceFields}
                                        BackPage={BackPage1}
                                        onPaymentChange={onPaymentChange}
                                        onDeliveryModeChange={onDeliveryModeChange}
                                        onPaymentReceiverChange={onPaymentReceiverChange}
                                        onModeChange={onModeChange}
                                        paymentOption={paymentOption}
                                        deliveryMode={deliveryMode}
                                        paymentReceiver={paymentReceiver}
                                        mode={mode}
                                        selectedPaymentType={selectedPaymentType}
                                        selectedDeliveryMode={selectedDeliveryMode}
                                        selectedPaymentReceiver={selectedPaymentReceiver}
                                        selectedMode={selectedMode}
                                        onSaveClick={onSaveClick1}
                                        GSTPercentageOptions={GSTPercentageOptions}
                                        onGstPercentChange={onGstPercentChange}
                                        selectedGSTPercentageOption={selectedGSTPercentageOption}
                                        executionOwnerOptions={executionOwnerOptions}
                                        onExecutionOwnerChange={onExecutionOwnerChange}
                                        selectedExectionOwner={selectedExectionOwner}
                                        selectedServiceCode={selectedServiceCode}
                                        onServiceCodeChange={onServiceCodeChange}
                                        serviceCodeOptions={serviceCodeOptions}

                                        expectedTat={expectedTat}
                                        handleExpectedTatChange={handleExpectedTatChange}
                                        isExpectedTatDisabled={isExpectedTatDisabled}
                                    />
                                </div>
                            </div>
                            :
                            ""
            }
        </div>
    )
}

export default ServiceCatalogueHome
